import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  data: string[][]
}

const CsvPreviewDataTabe = ({ data }: Props) => {
  const { t } = useTranslation()

  const header = useMemo(() => {
    return data[0].map((value, index) => (
      <TableCell align="left" key={index}>
        {value}
      </TableCell>
    ))
  }, [data])
  const rows = useMemo<ReactElement[]>(
    () =>
      data.slice(1, 5).map((value, index) => {
        return (
          <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            {value.map((value, index) => (
              <TableCell align="left" key={index}>
                {value}
              </TableCell>
            ))}
          </TableRow>
        )
      }),
    [data],
  )
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>{header}</TableRow>
        </TableHead>
        <TableBody>
          {rows.length === 0 ? (
            <TableRow>
              <TableCell align="center">
                <Typography variant="body2" color="textSecondary">
                  {t('common.noData')}
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            rows
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default CsvPreviewDataTabe
